// src/components/student/StudentBulkStatusPage.js
import React from 'react';
import { Box, Typography, Breadcrumbs, Link } from '@mui/material';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import StudentBulkStatus from './StudentBulkStatus';

const StudentBulkStatusPage = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Box mb={3}>
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
          <Link 
            color="inherit" 
            href="#" 
            onClick={(e) => {
              e.preventDefault();
              navigate('/students');
            }}
            sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
          >
            Students
          </Link>
          <Typography color="text.primary">Bulk Status Management</Typography>
        </Breadcrumbs>
      </Box>
      
      <StudentBulkStatus />
    </Box>
  );
};

export default StudentBulkStatusPage;